import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { SubscriptionDuration, SubscriptionType } from '../../types/plan.types';
import { useAppMutation } from '../use-app-mutation.hook';

export type ChangeSubscriptionDto = {
  amount: number;
  frequency: SubscriptionDuration;
  stakeholderLimit: number;
  type: SubscriptionType;
};

export const useChangeSubscription = () => {
  const { mutate: changeSubscription, isPending } = useAppMutation([QueryKey.CHANGE_SUBSCRIPTION], {
    mutationFn: ({ companyId, data }: { companyId: string; data: ChangeSubscriptionDto }) =>
      ApiService.patch(
        {
          endpoint: BackendRoute.COMPANIES,
          routePath: [companyId, 'subscription'],
        },
        { body: data },
      ),
  });
  return { changeSubscription, isPending };
};
